import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import styled, { css } from 'styled-components';
import { colorVariantsColorType } from 'types/product';

type AvailabilityMessageStyledProps = {
    isNotAvailable: boolean;
};

export const NameStyled = styled.div`
    text-align: left;
    width: 100%;
    padding-right: 10px;
`;

export const NameTitleStyled = styled(ExtendedNextLink)(
    ({ theme }) => css`
        line-height: 20px;

        color: ${theme.color.primary};
        font-size: 15px;
        font-weight: 400;
        text-decoration: none;
        letter-spacing: 0.5px;

        &:hover {
            text-decoration: none;
            color: ${theme.color.primary};
        }
    `,
);

export const VariantStyled = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 3px;
        line-height: 14px;

        font-size: 12px;
        letter-spacing: 0.5px;
        color: ${theme.color.grayDark};
    `,
);

export const VariantColorStyled = styled.div<colorVariantsColorType>(
    ({ theme, isLightColor, colorValue, colorImage }) => css`
        display: flex;
        align-items: center;
        width: 15px;
        height: 15px;
        margin-left: 10px;

        border-radius: 100%;
        background-color: ${colorValue};
        border: ${isLightColor ? `1px solid ${theme.color.grayDark}` : `none`};

        ${colorImage !== null &&
        css`
            /* background: transparent url(${colorImage}) no-repeat center center; */
            background-size: 15px 15px;
            border: none;
        `}
    `,
);

export const VariantTextStyled = styled.div(
    ({ theme }) => css`
        margin-left: 5px;
        line-height: 14px;

        font-size: 12px;
        letter-spacing: 0.5px;
        color: ${theme.color.primary};
    `,
);

export const AvailabilityMessageStyled = styled.div<AvailabilityMessageStyledProps>(
    ({ theme, isNotAvailable }) => css`
        line-height: 15px;
        margin-bottom: 4px;

        color: ${isNotAvailable ? theme.color.red : theme.color.green};
        font-weight: 700;
        font-size: 13px;
    `,
);
